const SUPPORTED_LANGUAGES = ['zh', 'en', 'vi'];
const DEFAULT_LANGUAGE = 'zh';
const LANGUAGE_STORAGE_KEY = 'language';
import localStorage from '@/utils/localStorage';
let _localStorage = new localStorage('qiuxiao2');

function normalizeLocale(value) {
  const locale = typeof value === 'string' ? value : value?.value;
  return (locale || '').toLowerCase().split('-')[0];
}

export function getApiLang(options = {}) {
  const localeSource = options.$i18n?.locale;
  const locale = normalizeLocale(localeSource);
  if (SUPPORTED_LANGUAGES.includes(locale)) {
    return locale;
  }
  const saved = normalizeLocale(_localStorage?.getItem?.(LANGUAGE_STORAGE_KEY));
  return SUPPORTED_LANGUAGES.includes(saved) ? saved : DEFAULT_LANGUAGE;
}
